import React from "react";
import { Accordion, Container, Col, Row } from "react-bootstrap";
import BillHeading from "../components/BillHeading/BillHeading";
import BillToggle from "../components/BillToggle/BillToggle";
import DocumentPanel from "../components/DocumentPanel/DocumentPanel";

function BillPageDesign() {
  // This object contains dummy data to display the design on the bill page.
  const placeholderBill = {
    title: "Grozījumi Civilprocesa likumā",
    description:
      "Aspernatur laudantium atque accusamus occaecati sunt aut dolorem. Dolores in distinctio esse amet. Eum rerum aspernatur commodi eum qui sunt magnam enim. Non omnis harum illum quo quibusdam pariatur possimus. Itaque quaerat sed laudantium ipsa. Et natus quia qui iusto quos et voluptate ea et.",
    documents: [
      {
        id: 1,
        title: "Bill document 1 title",
        content: (
          <>
            <p>
              Et consequuntur incidunt sit praesentium. Qui quo expedita iste
              voluptas. Soluta tempora eligendi odit ut tempora blanditiis sit.
              Enim nostrum ut suscipit molestias quasi autem. Eum est voluptas
              excepturi pariatur nihil molestiae. Est amet nihil sit dolores
              occaecati quia sit.
            </p>
            <p>
              Facere molestiae atque hic sequi inventore. Ipsum ut minus atque.
              Labore soluta id quibusdam sed ea quia atque est. Laborum
              similique aut ipsam. Omnis nam et qui ut doloribus quae sed quo.
              Voluptatibus officia nihil est et quia voluptate.
            </p>
            <p>
              Maiores delectus voluptatibus voluptates alias error dignissimos
              in ut commodi. Ipsam non autem odit ipsam voluptas. Est laboriosam
              est quaerat necessitatibus maxime. Laudantium earum commodi porro
              aut omnis facilis. Iste perferendis adipisci ab sed cupiditate rem
              voluptas excepturi delectus. Occaecati accusantium unde magni.
            </p>
            <p>
              Et consequuntur incidunt sit praesentium. Qui quo expedita iste
              voluptas. Soluta tempora eligendi odit ut tempora blanditiis sit.
              Enim nostrum ut suscipit molestias quasi autem. Eum est voluptas
              excepturi pariatur nihil molestiae. Est amet nihil sit dolores
              occaecati quia sit.
            </p>
          </>
        ),
        proposals: [
          {
            author: "Socially Active Team", // This will probably be some user object.
            publishedTime: "Thu Aug 19 2021 15:34:02 GMT+0200", // Some timestamp
            publishedStatus: false,
            content:
              "Est reprehenderit ut. Consectetur voluptas et iusto et qui numquam. Autem delectus delectus tenetur itaque velit ea. Exercitationem voluptas occaecati quod beatae soluta sunt explicabo dicta ut. Non vel fugiat officia architecto.",
          },
          {
            author: "Friends", // This will probably be some user object.
            publishedTime: "Fri Aug 20 2021 15:34:02 GMT+0200", // Some timestamp
            publishedStatus: false,
            content:
              "Maiores delectus voluptatibus voluptates alias error dignissimos in ut commodi. Ipsam non autem odit ipsam voluptas. Est laboriosam est quaerat necessitatibus maxime. Laudantium earum commodi porro aut omnis facilis. Iste perferendis adipisci ab sed cupiditate rem voluptas excepturi delectus. Occaecati accusantium unde magni.",
          },
        ],
      },
      {
        id: 2,
        title: "Bill document 2 title",
        content: (
          <>
            <p>
              Et consequuntur incidunt sit praesentium. Qui quo expedita iste
              voluptas. Soluta tempora eligendi odit ut tempora blanditiis sit.
              Enim nostrum ut suscipit molestias quasi autem. Eum est voluptas
              excepturi pariatur nihil molestiae. Est amet nihil sit dolores
              occaecati quia sit.
            </p>
            <p>
              Facere molestiae atque hic sequi inventore. Ipsum ut minus atque.
              Labore soluta id quibusdam sed ea quia atque est. Laborum
              similique aut ipsam. Omnis nam et qui ut doloribus quae sed quo.
              Voluptatibus officia nihil est et quia voluptate.
            </p>
            <p>
              Maiores delectus voluptatibus voluptates alias error dignissimos
              in ut commodi. Ipsam non autem odit ipsam voluptas. Est laboriosam
              est quaerat necessitatibus maxime. Laudantium earum commodi porro
              aut omnis facilis. Iste perferendis adipisci ab sed cupiditate rem
              voluptas excepturi delectus. Occaecati accusantium unde magni.
            </p>
            <p>
              Et consequuntur incidunt sit praesentium. Qui quo expedita iste
              voluptas. Soluta tempora eligendi odit ut tempora blanditiis sit.
              Enim nostrum ut suscipit molestias quasi autem. Eum est voluptas
              excepturi pariatur nihil molestiae. Est amet nihil sit dolores
              occaecati quia sit.
            </p>
          </>
        ),
      },
    ],
  };

  return (
    <>
      <BillHeading bill={placeholderBill} />
      <Container fluid className="py-8 px-0">
        <Row>
          <Col xl={8}>
            {placeholderBill.documents.length > 0 ? (
              <Accordion defaultActiveKey="0">
                {placeholderBill.documents.map((doc) => (
                  <BillToggle document={doc} key={doc.id}>
                    <DocumentPanel document={doc} />
                  </BillToggle>
                ))}
              </Accordion>
            ) : null}
          </Col>
        </Row>
      </Container>
    </>
  );
}

export default BillPageDesign;
